import React from "react";
import { useI18n } from "@/lib/i18n";
import { useSEO } from "@/components/common/SEO";
import { Reveal } from "@/components/common/Reveal";
import { SectionLabel } from "@/pages/Home";
import { COMPANY } from "@/data/company";

function LegalLayout({ title, sections, showResponsible }) {
  const { lang, t } = useI18n();
  const today = new Date().toLocaleDateString(lang === "en" ? "en-GB" : lang + "-ES");

  return (
    <div className="pt-32 pb-24">
      <section className="max-w-3xl mx-auto px-5 sm:px-8">
        <Reveal>
          <SectionLabel>{t("footer.legal")}</SectionLabel>
          <h1 className="mt-5 font-display font-extrabold tracking-tighter text-white text-4xl sm:text-5xl">{title}</h1>
          <p className="mt-4 font-mono text-xs uppercase tracking-widest text-white/40">{t("legal.updated")}: {today}</p>
        </Reveal>

        <Reveal delay={0.06} className="mt-10 rounded-2xl border border-white/10 bg-[#0A0A0A] p-6">
          <h2 className="font-display font-semibold text-white mb-2">{t("legal.responsible")}</h2>
          <div className="text-sm text-white/60 space-y-1">
            <p>{COMPANY.legalName}</p>
            <p>CIF: {COMPANY.cif}</p>
            <p>{COMPANY.registry} · IRUS: {COMPANY.irus}</p>
            <p>{COMPANY.city} · {COMPANY.email} · {COMPANY.phoneDisplay}</p>
          </div>
        </Reveal>

        <div className="mt-10 space-y-8">
          {sections.map((s, i) => (
            <Reveal key={i} delay={0.03}>
              <div>
                <h2 className="font-display text-xl font-semibold text-white mb-2">{s.h}</h2>
                <p className="text-white/65 leading-relaxed">{s.p}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}

export function Privacy() {
  const { lang, t } = useI18n();
  useSEO({ lang, title: `${t("legal.privacyTitle")} | HO-SYS`, description: t("legal.privacyTitle"), path: "/privacy" });
  return <LegalLayout title={t("legal.privacyTitle")} sections={t("legal.privacy")} showResponsible />;
}

export function LegalNotice() {
  const { lang, t } = useI18n();
  useSEO({ lang, title: `${t("legal.noticeTitle")} | HO-SYS`, description: t("legal.noticeTitle"), path: "/legal" });
  return <LegalLayout title={t("legal.noticeTitle")} sections={t("legal.notice")} />;
}
